import { isValid, parseISO } from 'date-fns';

export function transformEffectiveDateUIToModel(value: Date): string | null {
  if (!isValid(value)) {
    return null;
  }
  return value.toISOString(); // Return ISO string for valid Date
}

export function transformEffectiveDateModelToUI(value: string): Date | null {
  const parsedDate = parseISO(value);

  if (!isValid(parsedDate)) {
    return null; // Return null if the parsed date is invalid
  }

  return parsedDate; // Return the parsed Date object
}
